import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import styles from './Login.module.css';
import { useDispatch, useSelector } from "react-redux";
import {
    checkMSToken
} from './loginSlice'
import { useNavigate } from "react-router-dom";
import { validateEmail } from "../../app/utils/helpers"
import Langs from "../../app/lang/langs";
import logo from "../../assets/images/Logo-Groupe-Vital-Blanc-Baseline.png";
import { SignInButton } from '../../components/buttons/SignInButton';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../app/utils/authConfig";
import { ThemeButton } from '../../components/buttons/ThemeButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';

function getDeviceType() {
    const w = window.innerWidth;
    if (w <= 768) return 2;   // mobile
    if (w <= 1200) return 3;  // tablet
    return 1;                 // desktop
}

export function LoginPage(props) {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const isAuthenticated = useIsAuthenticated()
    const isLoading = useSelector((state) => state.common.isLoading)
    const loginError = useSelector((state) => state.login.loginError)
    const formView = useSelector((state) => state.login.formView)
    const isMobileRedux = useSelector((state) => state.settings.isMobile)
    const [localDevice, setLocalDevice] = useState(getDeviceType)
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [formError, setFormError] = useState('')
    const [collabsInput, setCollabsInput] = useState(false)
    const { instance, accounts, inProgress } = useMsal()

    const isMobile = isMobileRedux || localDevice

    useEffect(() => {
        const onResize = () => setLocalDevice(getDeviceType());
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [])


    useEffect(() => {
        if (isAuthenticated && !isLoading) {
            const request = {
                ...loginRequest,
                account: accounts[0]
            };
            instance.acquireTokenSilent(request).then((response) => {
                dispatch(checkMSToken(response))
            }).catch((e) => {
                instance.acquireTokenPopup(request).then((response) => {
                    dispatch(checkMSToken(response))
                })
            })
        }
    }, [isAuthenticated])



    // Mobile / Tablet layout (isMobile === 2 or 3)
    if (isMobile === 2 || isMobile === 3) {
        return (
            <Box
                className={`${styles.background} ${styles.mobileBackground}`}
                sx={{
                    minHeight: '100vh',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: isMobile === 2 ? 2.5 : 5,
                    py: 4,
                    boxSizing: 'border-box',
                }}
            >
                {/* Floating particles layer */}
                <Box className={styles.mobileParticles}>
                    <Box className={`${styles.mobileParticle} ${styles.mobileParticle1}`} />
                    <Box className={`${styles.mobileParticle} ${styles.mobileParticle2}`} />
                    <Box className={`${styles.mobileParticle} ${styles.mobileParticle3}`} />
                    <Box className={`${styles.mobileParticle} ${styles.mobileParticle4}`} />
                    <Box className={`${styles.mobileParticle} ${styles.mobileParticle5}`} />
                    <Box className={`${styles.mobileParticle} ${styles.mobileParticle6}`} />
                </Box>

                <Fade in timeout={600}>
                    <Box
                        className={styles.mobileContent}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '100%',
                            maxWidth: isMobile === 2 ? 360 : 440,
                        }}
                    >
                        {/* Logo with floating animation */}
                        <Box
                            component="img"
                            src={logo}
                            alt="logo"
                            className={styles.mobileLogo}
                            sx={{
                                width: isMobile === 2 ? '70%' : '55%',
                                maxWidth: 280,
                                mb: 5,
                            }}
                        />

                        {/* Orb glow behind card */}
                        <Box sx={{ position: 'relative', width: '100%' }}>
                            <Box className={styles.mobileOrb} />

                            {/* Glassmorphic card */}
                            <Box className={styles.mobileCard}
                                sx={{
                                    width: '100%',
                                    px: isMobile === 2 ? 2.5 : 4,
                                    py: isMobile === 2 ? 4 : 5,
                                    position: 'relative',
                                }}
                            >
                                {/* Card inner with corner accents */}
                                <Box className={styles.mobileCardInner}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: 2.5,
                                    }}
                                >
                                    {/* Welcome text with shimmer */}
                                    <Typography
                                        className={styles.mobileWelcomeText}
                                        sx={{
                                            fontFamily: "'Inter', 'Roboto', sans-serif",
                                            fontSize: isMobile === 2 ? '24px' : '28px',
                                            lineHeight: 1.3,
                                            textAlign: 'center',
                                        }}
                                    >
                                        <Langs str='WELCOME_TEXT' />
                                    </Typography>

                                    {/* Decorative divider */}
                                    <Box className={styles.mobileDivider} />

                                    {/* Sign in button */}
                                    <Box
                                        className={styles.mobileButtonWrap}
                                        sx={{
                                            width: '100%',
                                            mt: 1,
                                            '& button': {
                                                fontSize: '16px',
                                                minHeight: '52px',
                                                width: '100%',
                                                borderRadius: '14px !important',
                                            },
                                        }}
                                    >
                                        <SignInButton />
                                    </Box>
                                </Box>
                            </Box>
                        </Box>

                        {/* Brand mark */}
                        <Box className={styles.mobileBrandMark}>
                            Groupe Vital
                        </Box>
                    </Box>
                </Fade>
            </Box>
        );
    }

    // Desktop layout (isMobile === 1)
    return (
        <Box
            className={`${styles.background} ${styles.desktopBackground}`}
            sx={{
                minHeight: '100vh',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: { lg: 6, xl: 10 },
                py: 6,
                boxSizing: 'border-box',
            }}
        >
            {/* Floating particles layer */}
            <Box className={styles.desktopParticles}>
                <Box className={`${styles.desktopParticle} ${styles.desktopParticle1}`} />
                <Box className={`${styles.desktopParticle} ${styles.desktopParticle2}`} />
                <Box className={`${styles.desktopParticle} ${styles.desktopParticle3}`} />
                <Box className={`${styles.desktopParticle} ${styles.desktopParticle4}`} />
                <Box className={`${styles.desktopParticle} ${styles.desktopParticle5}`} />
                <Box className={`${styles.desktopParticle} ${styles.desktopParticle6}`} />
            </Box>

            <Fade in timeout={600}>
                <Box
                    className={styles.desktopContent}
                    sx={{
                        width: '100%',
                        maxWidth: 1240,
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        alignItems: 'center',
                        columnGap: { lg: 8, xl: 12 },
                    }}
                >
                    {/* Left: branding pane */}
                    <Box
                        className={styles.desktopBrandPane}
                        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                    >
                        <Box
                            component="img"
                            src={logo}
                            alt="logo"
                            className={styles.desktopLogo}
                            sx={{ width: '68%', maxWidth: 340, mb: 5 }}
                        />

                        <Typography
                            className={styles.desktopHeadline}
                            sx={{
                                fontFamily: "'Inter', 'Roboto', sans-serif",
                                fontSize: { lg: '40px', xl: '48px' },
                                fontWeight: 300,
                                lineHeight: 1.15,
                            }}
                        >
                            <Langs str='WELCOME_TEXT' />
                        </Typography>

                        <Box className={styles.desktopAccentLine} sx={{ width: 88, my: 3 }} />

                        <Typography
                            className={styles.desktopSubtitle}
                            sx={{
                                fontFamily: "'Inter', 'Roboto', sans-serif",
                                fontSize: '17px',
                                fontWeight: 300,
                                lineHeight: 1.6,
                                color: 'rgba(255, 255, 255, 0.72)',
                                maxWidth: 420,
                            }}
                        >
                            <Langs str='LOGIN_SUBTITLE' />
                        </Typography>

                        <Box className={styles.desktopBrandMark} sx={{ mt: 6 }}>
                            Groupe Vital
                        </Box>
                    </Box>

                    {/* Right: sign-in card */}
                    <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                        <Box className={styles.desktopOrb} />

                        <Box
                            className={styles.desktopCard}
                            sx={{ width: '100%', maxWidth: 560, px: 5, py: 7 }}
                        >
                            <Box
                                className={styles.desktopCardInner}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 3,
                                }}
                            >
                                <Typography
                                    className={styles.desktopCardTitle}
                                    sx={{
                                        fontFamily: "'Inter', 'Roboto', sans-serif",
                                        fontSize: '24px',
                                        fontWeight: 400,
                                        color: '#fff',
                                        textAlign: 'center',
                                    }}
                                >
                                    <Langs str='LOGIN_CARD_TITLE' />
                                </Typography>

                                <Box className={styles.desktopDivider} />

                                <Box
                                    className={styles.desktopButtonWrap}
                                    sx={{
                                        width: '100%',
                                        mt: 1,
                                        '& button': {
                                            fontSize: '16px',
                                            minHeight: '54px',
                                            width: '100%',
                                            borderRadius: '14px !important',
                                        },
                                    }}
                                >
                                    <SignInButton />
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Fade>
        </Box>
    );
}
